import { Header, About, Pets, Help, Donation, Footer } from '../components/Sections';

function App() {
  return (
    <>
      <Header />
      <About />
      <Pets />
      <Help />
      <Donation />
      <Footer />
    </>
  );
}

export default App;
